import i18n from "../../../../i18n"

export async function shipmentsIndexUseCase(url, page, per_page, search, shipping_service, cod, sort_by, shipmentRepository) {
    const result = await shipmentRepository.index(url, page, per_page, search, shipping_service, cod, sort_by);

    var type = (cod == 'false' ? 'prepaid' : 'cod');

    var pending_actions = [{
        name: i18n.t('fulfillments_' + type + '_pendings.details'),
        icon: {
            color: 'accent',
            icon: 'info'
        },
        method: 'showDetails',
    },
    {
        name: i18n.t('fulfillments_' + type + '_pendings.edit'),
        icon: {
            color: 'accent',
            icon: 'mode_edit'
        },
        link: '/pending-shipments/' + type + '/edit/0',
    },
    {
        name: i18n.t('fulfillments_' + type + '_pendings.delete'),
        icon: {
            color: 'accent',
            icon: 'delete'
        },
        method: 'askDelete',
    },
    {
        name: i18n.t('fulfillments_' + type + '_pendings.supply'),
        icon: {
            color: 'accent',
            icon: 'send'
        },
        method: 'supplyOrderModal',
    },
    {
        name: i18n.t('fulfillments_' + type + '_pendings.change_parcel'),
        icon: {
            color: 'accent',
            icon: 'swap_horizontal_circle'
        },
        method: 'changeParcelModal',
    }];

    var in_process_actions = [{
        name: i18n.t('fulfillments_' + type + '_in_process.details'),
        icon: {
            color: 'accent',
            icon: 'info'
        },
        method: 'showDetails',
    },
    {
        name: i18n.t('fulfillments_' + type + '_sent.edit'),
        icon: {
            color: 'accent',
            icon: 'mode_edit'
        },
        link: '/sent-shipments/' + type + '/edit/0',
    },
    {
        name: i18n.t('fulfillments_' + type + '_in_process.restore'),
        icon: {
            color: 'accent',
            icon: 'history'
        },
        method: 'askRestore',
    },
    {
        name: i18n.t('fulfillments_' + type + '_in_process.delete'),
        icon: {
            color: 'accent',
            icon: 'delete'
        },
        method: 'askDelete',
    },
    {
        name: i18n.t('fulfillments_' + type + '_in_process.download_guides'),
        icon: {
            color: 'accent',
            icon: 'label'
        },
        method: 'downloadLabel',
    },
    {
        name: i18n.t('fulfillments_' + type + '_in_process.download_invoice'),
        icon: {
            color: 'accent',
            icon: 'description'
        },
        method: 'downloadInvoice',
    }];

    var sent_actions = [{
        name: i18n.t('fulfillments_' + type + '_sent.details'),
        icon: {
            color: 'accent',
            icon: 'info'
        },
        method: 'showDetails',
    },
    {
        name: i18n.t('fulfillments_' + type + '_sent.edit'),
        icon: {
            color: 'accent',
            icon: 'mode_edit'
        },
        link: '/sent-shipments/' + type + '/edit/10000',
    },
    {
        name: i18n.t('fulfillments_' + type + '_in_process.restore'),
        icon: {
            color: 'accent',
            icon: 'history'
        },
        method: 'askRestore',
    },
    {
        name: i18n.t('fulfillments_' + type + '_sent.delete'),
        icon: {
            color: 'accent',
            icon: 'delete'
        },
        method: 'askDelete',
    }]

    var returned_actions = [{
        name: i18n.t('fulfillments_' + type + '_returns.details'),
        icon: {
            color: 'accent',
            icon: 'info'
        },
        method: 'showDetails',
    },
    {
        name: i18n.t('fulfillments_' + type + '_returns.incidence'),
        icon: {
            color: 'accent',
            icon: 'warning_amber'
        },
        link: '/shipments/' + type + '/incidence/10000',
    },
    {
        name: i18n.t('fulfillments_' + type + '_returns.restore'),
        icon: {
            color: 'accent',
            icon: 'restore'
        },
        method: 'askRestore',
    }];

    for (var i = 0; i < result.data.data.length; i++) {
        result.data.data[i] = result.data.data[i].attributes;

        const entity = new shipmentRepository.model_index(result.data.data[i]);

        if (entity.isValid() != true) {
            console.log(entity)
            throw new Error("Shipment index inválido");
        }

        if (url == "getPendingOrders") {
            if (shipping_service == "OTRA") result.data.data[i]['actions'] = JSON.parse(JSON.stringify(pending_actions));
            else result.data.data[i]['actions'] = JSON.parse(JSON.stringify(pending_actions.slice(0, -1)));

            result.data.data[i]['actions'][1].link = '/pending-shipments/' + type + '/edit/' + result.data.data[i].id
        }
        else if (url == "getInProcesOrders") {
            result.data.data[i]['actions'] = JSON.parse(JSON.stringify(in_process_actions));
            result.data.data[i]['actions'][1].link = '/sent-shipments/' + type + '/edit/' + result.data.data[i].id
        }
        else if (url == "getSentOrders") {
            result.data.data[i]['actions'] = JSON.parse(JSON.stringify(sent_actions));
            result.data.data[i]['actions'][1].link = '/sent-shipments/' + type + '/edit/' + result.data.data[i].id
        }
        else if (url == "getReturnedOrders") {
            result.data.data[i]['actions'] = JSON.parse(JSON.stringify(returned_actions));
            result.data.data[i]['actions'][1].link = '/shipments/' + type + '/incidence/' + result.data.data[i].id
        }

        result.data.data[i].parameters = { id: result.data.data[i].id, unique_order_number: result.data.data[i].unique_order_number, shipment_number: result.data.data[i].shipment_number };
    }

    return result;
}